module.exports = __webpack_public_path__ + "static/media/roo_wor_haz_lev.456b5f21.png";